<template>
  <div class="pop-five">

    <div class="a-box beige">
      <div class="pure-g">
        <div class="pure-u-1-1 pure-u-md-1-2 fixed-text-box" v-html="$lang.f5_1_header"></div>
        <div class="pure-u-1-2 pure-u-md-1-2 icon-holder">
          <div class="icon f5_main"></div>
        </div>
      </div>
    </div>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang.f5_2_header"></h2>
          <p v-html="$lang.f5_2_ingress"></p>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <!-- Big slider -->
    <bg-slider
      :slides="dataSlides.slides"
    ></bg-slider>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2">
          <h2 v-html="$lang.f5_3_header"></h2>
          <p v-html="$lang.f5_3_ingress"></p>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <div class="lvl-section brains">
      <div class="pure-g">
        <div class="lvl-box pure-u-1-1 pure-u-md-1-4">
          <div class="icon f5_3"></div>
          <h3 v-html="$lang.f5_4_1_header"></h3>
          <ul v-html="$lang.f5_4_1_ul"></ul>
        </div>
        <div class="lvl-box pure-u-1-1 pure-u-md-1-4">
          <div class="icon f5_3"></div>
          <h3 v-html="$lang.f5_4_2_header"></h3>
          <ul v-html="$lang.f5_4_2_ul"></ul>
        </div>
        <div class="lvl-box pure-u-1-1 pure-u-md-1-4">
          <div class="icon f5_3"></div>
          <h3 v-html="$lang.f5_4_3_header"></h3>
          <ul v-html="$lang.f5_4_3_ul"></ul>
        </div>
        <div class="lvl-box pure-u-1-1 pure-u-md-1-4">
          <div class="icon f5_3"></div>
          <h3 v-html="$lang.f5_4_4_header"></h3>
          <ul v-html="$lang.f5_4_4_ul"></ul>
        </div>
      </div>
    </div>

    <div class="note-box light-beige">
      <div class="pure-g">
        <div class="pure-u-1-1 pure-u-md-2-3">
          <div class="icon f-note"></div>
          <p v-html="$lang.f5_note"></p>
        </div>
        <div class="pure-u-md-1-3"></div>
      </div>
    </div>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-1">
          <h2 v-html="$lang.f5_5_header"></h2>
        </div>
      </div>
    </div>

    <div class="lvl-section">
      <div class="pure-g">
        <div class="lvl-box pure-u-1-1 pure-u-md-1-2">
          <p v-html="$lang.f5_5_txt"></p>
        </div>
        <div class="lvl-box pure-u-1-1 pure-u-md-1-2">
          <ul v-html="$lang.f5_5_ul"></ul>
        </div>
      </div>
    </div>

    <div class="p-section maroon">
      <div class="p-box pure-g">
        <div class="box-left pure-u-1-1 pure-u-md-1-2" v-touch:tap="toggleRefs">
          <h2 class="toggle-ref">{{$lang.refs}} <span :class="{'open': showRefs}"></span></h2>
        </div>
        <div class="pure-u-1-1 pure-u-md-1-2"></div>
      </div>
    </div>

    <!-- Refferens -->
    <div class="lvl-section refs">
      <transition name="show-ref">
        <div v-show="showRefs" class="pure-g refs-container">
          <div class="lvl-box refs pure-u-1-1 pure-u-md-1-3">
            <div class="lvl-body" v-html="$lang.f5_ref_1"></div>
          </div>
          <div class="lvl-box refs pure-u-1-1 pure-u-md-1-3">
            <div class="lvl-body"></div>
          </div>
          <div class="lvl-box refs pure-u-1-1 pure-u-md-1-3">
            <div class="lvl-body"></div>
          </div>
        </div>
      </transition>
    </div>

  </div>
</template>

<script>
import BGSlider from '../../../components/big-slider'
import DataSlider from '../../../assets/data/fact_5_s.json'

export default {
  name: 'fact-five',
  data () {
    return {
      dataSlides: DataSlider,
      showRefs: false
    }
  },
  methods: {
    toggleRefs () {
      let self = this
      return self.onToggleRefs()
    },
    onToggleRefs () {
      this.showRefs = !this.showRefs
    }
  },
  components: {
    'bg-slider': BGSlider
  }
}
</script>



// WEBPACK FOOTER //
// src/components/facts/fact5/index.vue